Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $(".x-address-group-list"), wrapper;

    if ($wrapper.length < 1)
        return;

    wrapper = $wrapper.get(0);
    var model = null;

    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    wrapper.update = function () {

        model.Configs.AddressGroupsPermissions = {};
        model.Configs.AddressGroupsPermissions.Insert = $wrapper.data('insert');
        model.Configs.AddressGroupsPermissions.Update = $wrapper.data('update');
        model.Configs.AddressGroupsPermissions.Delete = $wrapper.data('delete');

        var html = Vendd.Handlebars.parse("accountAddressGroupList_A", model);
        $wrapper.html(html);

        wrapper.loading(false);
    };

    $wrapper.on('click', '.js-address-group-delete', function (e) {
        var $address = $(this).closest('.x-address-group-box');
        var id = $address.data('address-group-id');

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.DeleteAddressGroup(id));
    });

    $wrapper.on('click', '.js-address-group-edit', function (e) {
        var $address = $(this).closest('.x-address-group-box');
        var id = $address.data('address-group-id');

        var addressGroupModel = clone(model.AddressGroups.find(function (addressGroup) { return id === addressGroup.Id; }));

        $.extend(addressGroupModel, {
            Literals: model.Literals,
            Configs: model.Configs
        });

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.OpenAddressGroupEditForm(addressGroupModel));
        return false;
    });

    $wrapper.on('click', '.js-new-address-group-add', function () {
        var newAddressGroupModel = Vendd.Account.GetNewAddressGroup(model);

        newAddressGroupModel = $.extend(newAddressGroupModel, {
            Literals: model.Literals,
            Configs: model.Configs
        });

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.OpenAddressGroupEditForm(newAddressGroupModel));
        return false;

    });

    wrapper.loading(true);

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.GetAddressGroupsSuccess, wrapper, function (envelope) {
        model = envelope.message.data.model;
        wrapper.update();
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.AddressGroupModelChanged, wrapper, function (envelope) {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.GetAddressGroups());
    });

    Vendd.MessageBus.subscribe(Vendd.Account.Messages.DeleteAddressGroupSuccess, wrapper, function (envelope) {
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.GetAddressGroups());
    });

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Account.Messages.GetAddressGroups());

});